import { ThemeConfig } from '../types';

// Neon Workflow Theme — a single cohesive n8n-inspired automation canvas.
// Dark base, neon accents, node cards and animated data-flow connectors.
const neon: ThemeConfig = {
  name: 'neon',
  fontFamily: "'Space Grotesk', 'Inter', sans-serif",
  colors: {
    primary: '#22e6ff', // neon cyan
    secondary: '#9d5cff', // neon purple
    background: '#06060f', // canvas base
    text: '#e8ebff', // ink main
    accent: '#ff3df0', // neon magenta
  },
  layout: {
    containerStyle: 'max-w-6xl mx-auto px-5 sm:px-6 lg:px-8',
    headerStyle: 'py-4 sticky top-0 z-50 backdrop-blur-xl',
    sectionStyle: 'py-16 md:py-24 relative',
  },
  animation: {
    transition: 'transition-all duration-300 ease-out',
    hover: 'hover:-translate-y-1',
    scale: 'transform hover:scale-105',
  },
};

export const themes = {
  neon,
};

// Making sure this file is a module
export type { ThemeConfig };
